module.exports = __webpack_public_path__ + "static/img/9.cd877f77.jpg";